import { Component, Inject, OnInit } from '@angular/core';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { Subject } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { Utils } from '../../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { AssignContactPopupComponent } from './assigncontact-popup/assigncontact-popup.component';
import { CreateContactPopupComponent } from './createcontact-popup/createcontact-popup.component';
import { ToastrService } from 'ngx-toastr';
import { BranchexcellenceChangelogFormComponent } from '../../branchexcellence-changelog-form/branchexcellence-changelog-form.component';


@Component({
    selector: 'branchcontact',
    templateUrl: './branchcontact.component.html',
    styleUrls: ['./branchcontact.component.less',
        '../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class BranchContactComponent implements OnInit {

    protected _onDestroy = new Subject<void>();
    public dataSource = new MatTableDataSource<BranchContact>();
    columnsToDisplay = ['ContactName', 'ContactEmail', 'ContactCategory', 'actions', 'ChangeLog'];
    createAction = 'Create';
    editAction = 'Edit/Delete';
    timeoutFunction: any;
    subscriptionManagementId: any;
    subscriptionWaveId: any;
    subscriptions: any[] = [];
    assessmentId: number = -1;
    private currentMgmtId: string = '';
    private currentWaveId: number = -1;

    list: BranchContact[] = [];

    constructor(
        public defaults: DefaultValuesService
        , private dialogForm: MatDialog
        , private http: HttpClient
        , @Inject('BASE_URL') private baseUrl: string
        , private toastrService: ToastrService
    ) {
    }

    ngOnInit() {
        if (!this.defaults.isMersyAdminBranchExcellenceUser && !this.defaults.isMersyCoachBranchExcellenceUser) {
            this.columnsToDisplay = this.columnsToDisplay.filter(item => item !== 'actions');
        }
    }

    ngAfterViewInit() {
        this.subscriptionManagementId = this.defaults.managementIdMessageChanges$.subscribe(() => {
            this.getProperties();
        });
        this.subscriptionWaveId = this.defaults.wave$.subscribe(() => {
            this.getProperties();
        })
    }

    getProperties() {
        if (!this.defaults.managementid || this.defaults.managementid === '-1') return;
        const newWaveId = (this.defaults.waveId && this.defaults.waveId > 0) ? this.defaults.waveId : -1;
        if (this.currentMgmtId === this.defaults.managementid && this.currentWaveId === newWaveId) return;
        this.currentMgmtId = this.defaults.managementid;
        this.currentWaveId = newWaveId;
        this.getBranchContacts();
    }

    // unsubscribe to events when component is destroyed
    ngOnDestroy(): void {
        this.subscriptionManagementId.unsubscribe();
        this.subscriptionWaveId.unsubscribe();
    }

    getBranchContacts() {
        Utils.httpGetAdminBranchContacts(
            this.http,
            this.baseUrl,
            this.defaults.waveId,
            this,
            function (tthis: BranchContactComponent, list: any) {
                tthis.dataSource.data = list
            },
            null
        )
    }

    onRemoveContact(id: number) {
        Utils.httpUnassignContact(
            this.http,
            this.baseUrl,
            id,
            this.defaults.waveId,
            this,
            function (tthis: BranchContactComponent, result: any) {
                tthis.getBranchContacts();
                if (result)
                    tthis.toastrService.success('Contact was unassigned successfully!');
                else
                    tthis.toastrService.error('Contact could not be unassigned. Please, contact with administrator');
            }, null
        )
    }

    openCreateContactPopup(Action) {
        const dialog = this.dialogForm.open(CreateContactPopupComponent, {
            panelClass: ['custom-mat-dialog_v2', 'dialogNgselect'],
            disableClose: true,
            data: {
                action: Action
            },
        });
        if (Action != this.createAction)
        {
            dialog.afterClosed().subscribe(() => {
                this.getBranchContacts();
            });
        }
    }

    openAddContactPopup() {
        const dialog = this.dialogForm.open(AssignContactPopupComponent, {
            panelClass: ['custom-mat-dialog_v2', 'dialogNgselect'],
            disableClose: true,
            data: {},
        })
        dialog.afterClosed().subscribe(() => {
            this.getBranchContacts()
        })
    }

    onHistoryDetail(element: BranchContact, type: string) {

        var branchContactId = 0;

        if (element.BranchContactId != undefined)
            branchContactId = element.BranchContactId;

        const Dialog = this.dialogForm.open(BranchexcellenceChangelogFormComponent, {
            disableClose: false,
            data: {
                element: element,
                id: branchContactId,
                dataType: type
            }
        });
        Dialog.afterClosed().subscribe(() => {
        });
    }

}
